import { DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RoutingPerformanceMonitorService } from '../../services/routing-performance-monitor.service';

@Component({
  selector: 'app-routing-performance-dashboard',
    standalone: true,
  templateUrl: './routing-performance-dashboard.component.html',
  styleUrls: ['./routing-performance-dashboard.component.less'],
    imports: [
        DecimalPipe
    ]
})
export class RoutingPerformanceDashboardComponent implements OnInit {
  performanceStats: any = {};
  slowestRoutes: any[] = [];
  performanceReport: string = '';

  constructor(
    private performanceMonitor: RoutingPerformanceMonitorService
  ) {}

  ngOnInit(): void {
    this.refreshData();
  }

  refreshData(): void {
    this.performanceStats = this.performanceMonitor.getPerformanceStats();
    this.slowestRoutes = this.performanceMonitor.getSlowestRoutes(10);
    this.performanceReport = this.performanceMonitor.generatePerformanceReport();
  }

  exportData(): void {
    const data = this.performanceMonitor.exportPerformanceData();
    const blob = new Blob([data], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `routing-performance-${Date.now()}.json`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  clearData(): void {
    if (confirm('Are you sure you want to clear all performance data?')) {
      this.performanceMonitor.clearMetrics();
      this.refreshData();
    }
  }

  getPerformanceClass(duration: number): string {
    if (duration < 100) return 'fast';
    if (duration < 500) return 'moderate';
    if (duration < 1000) return 'slow';
    return 'very-slow';
  }

  getSuccessRateClass(rate: number): string {
    if (rate >= 95) return 'excellent';
    if (rate >= 90) return 'good';
    if (rate >= 80) return 'fair';
    return 'poor';
  }
}
